export default __webpack_public_path__ + "static/media/card4-ecom.949a2fef.jpg";